export var Paths;

(function (Paths) {
  Paths["ListVideos"] = "/me/likes";
})(Paths || (Paths = {}));